import EnvironmentStatus from "rwb/pages/project/types/enums/environmentStatus";
import ComputeEnvironment from "rwb/types/interfaces/computeEnvironment";
import { useFetcher } from "~/hooks/useFetcher";
import { cn } from "~/lib/utils";

const { VITE_RWB_API } = import.meta.env;

/**
 * Running-environment indicator for a project card, matching the legacy
 * workbench card's status dot + count (`rwb/pages/projects/components/EnvironmentsStatus.tsx`)
 * -- a plain presence/count readout rather than that card's full
 * list-with-actions tooltip, since a project card isn't a management surface.
 */
export const ProjectCardEnvironmentIndicator = ({
  workbenchId,
}: {
  workbenchId: number | null;
}) => {
  const { data } = useFetcher<ComputeEnvironment[]>(
    workbenchId ? `${VITE_RWB_API}/environments?project_id=${workbenchId}` : null
  );

  if (!data?.length) {
    return null;
  }

  const hasRunning = data.some((env) => env.status === EnvironmentStatus.RUNNING);

  return (
    <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <span
        className={cn(
          "size-2 shrink-0 rounded-full",
          hasRunning ? "bg-green-600 dark:bg-green-500" : "bg-muted-foreground/30"
        )}
      />
      {data.length} {data.length === 1 ? "environment" : "environments"}
    </span>
  );
};
